import { IOrder } from '../../../types/store';
import { objectIsEmpty } from '../../../../shared/utils/objectHelper';

export const isEmptyCloudConnect = (order: IOrder): boolean => objectIsEmpty(order.cloudConnect);
